import { Temporal } from "temporal-polyfill";

/**
 * Formats a calendar date string (YYYY-MM-DD) for display. Parsing as a
 * `PlainDate` avoids the timezone shift `new Date("YYYY-MM-DD")` introduces.
 */
export function formatPlainDate(date: string): string {
  return Temporal.PlainDate.from(date).toLocaleString(undefined, {
    dateStyle: "medium",
  });
}
